import { render, staticRenderFns } from "./DashboardDonePlanItems.vue?vue&type=template&id=4c266e4e"
import script from "./DashboardDonePlanItems.vue?vue&type=script&lang=ts"
export * from "./DashboardDonePlanItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports